import React from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner, Alert, Image, Accordion, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Este componente recebe todos os dados e funções de que precisa como props
const TemplateDefault = ({
    entidade,
    servico,
    formData,
    submitStatus,
    isLoading,
    handleChange,
    handleSubmit,
    setShowOfferModal
}) => {
    return (
        <>
            {/* Seção Hero */}
            <section className="lp-hero" style={{ backgroundImage: `url(${servico.imagem_hero_path})` }}>
                <div className="lp-hero-overlay"></div>
                <Container className="lp-hero-content">
                    <Row className="align-items-center">
                        <Col lg={7} className="text-white text-center text-lg-start">
                            <h1 className="display-4 fw-bold">{servico.titulo_hero}</h1>
                            <p className="lead my-4">{servico.subtitulo_hero}</p>
                        </Col>
                        <Col lg={5} id="form-top">
                            <Card className="p-4 shadow-lg">
                                <Card.Body>
                                    {submitStatus.submitted ? (
                                        <Alert variant={submitStatus.variant} className="text-center">
                                            <Alert.Heading>{submitStatus.variant === 'success' ? 'Obrigado!' : 'Ops!'}</Alert.Heading>
                                            <p className="mb-0">{submitStatus.message}</p>
                                        </Alert>
                                    ) : (
                                        <>
                                            <h4 className="text-center mb-4">Comece sua transformação</h4>
                                            <Form onSubmit={handleSubmit}>
                                                <InputGroup className="mb-3">
                                                    <InputGroup.Text><FontAwesomeIcon icon="user" /></InputGroup.Text>
                                                    <Form.Control type="text" name="nome" placeholder="Nome Completo" value={formData.nome} onChange={handleChange} required />
                                                </InputGroup>
                                                <InputGroup className="mb-3">
                                                    <InputGroup.Text><FontAwesomeIcon icon="envelope" /></InputGroup.Text>
                                                    <Form.Control type="email" name="email" placeholder="Seu melhor e-mail" value={formData.email} onChange={handleChange} required />
                                                </InputGroup>
                                                <InputGroup className="mb-3">
                                                    <InputGroup.Text><FontAwesomeIcon icon="phone" /></InputGroup.Text>
                                                    <Form.Control type="tel" name="telefone" placeholder="Telefone / WhatsApp" value={formData.telefone} onChange={handleChange} required />
                                                </InputGroup>
                                                <div className="d-grid"><Button variant="primary" type="submit" size="lg" disabled={isLoading}>{isLoading ? <Spinner as="span" size="sm" /> : servico.texto_cta_principal}</Button></div>
                                            </Form>
                                        </>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Seção de Benefícios */}
            <section className="py-5 bg-light">
                <Container>
                    <h2 className="text-center mb-5">{servico.titulo_beneficios}</h2>
                    <Row>
                        {servico.lista_beneficios.map((beneficio, index) => (
                            <Col md={4} key={index} className="mb-4">
                                <Card className="h-100 border-0 shadow-sm">
                                    <Card.Body className="d-flex flex-column align-items-center text-center">
                                        <div className="display-4 mb-3">{beneficio.icone}</div>
                                        <Card.Title as="h5">{beneficio.titulo}</Card.Title>
                                        <Card.Text>{beneficio.descricao}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Seção Antes e Depois */}
            {servico.imagens_antes_depois && servico.imagens_antes_depois.length > 0 && (
                <section className="py-5">
                    <Container>
                        <h2 className="text-center mb-5">{servico.titulo_antes_depois}</h2>
                        <Row className="g-4">
                            {servico.imagens_antes_depois.map((img, index) => (
                                <Col md={6} key={index}>
                                    <Row className="g-0 border rounded shadow-sm">
                                        <Col><Image src={img.antes} fluid /></Col>
                                        <Col><Image src={img.depois} fluid /></Col>
                                    </Row>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>
            )}

            {/* Seção de Oferta */}
            <section className="py-5 bg-primary text-white">
                <Container className="text-center">
                    <h2 className="fw-bold">{servico.titulo_oferta}</h2>
                    <div className="price-tag-offer my-4">
                        <span className="price-old">{servico.preco_antigo}</span>
                        <span className="price-new">{servico.preco_novo}</span>
                    </div>
                    <p className="lead">{servico.texto_urgencia}</p>
                    <Button variant="light" size="lg" onClick={() => setShowOfferModal(true)}>Eu Quero Essa Oferta!</Button>
                </Container>
            </section>

            {/* Seção de FAQ */}
            <section className="py-5">
                <Container>
                    <h2 className="text-center mb-5">{servico.titulo_faq}</h2>
                    <Row className="justify-content-center">
                        <Col md={8}>
                            <Accordion defaultActiveKey="0">
                                {servico.lista_faq.map((faq, index) => (
                                    <Accordion.Item eventKey={String(index)} key={index}>
                                        <Accordion.Header>{faq.pergunta}</Accordion.Header>
                                        <Accordion.Body>{faq.resposta}</Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default TemplateDefault;
